export const KONTORO_KEY = 'kontoroVariables'
export const ACTION_TYPE_ADD = 'kontoroVariables.add'

export const PRIXE_TAX_VAR_KEY = 'rr_taxes'
